import * as React from 'react';
import { Divider } from '../../Divider';
import { classes } from './ActionsMenuLayoutDivider.st.css';
const ActionsMenuLayoutDivider = (props) => (React.createElement(Divider, { ...props, className: classes.root }));
ActionsMenuLayoutDivider.displayName = 'ActionsMenuLayout.Divider';
export { ActionsMenuLayoutDivider };
//# sourceMappingURL=ActionsMenuLayoutDivider.js.map